// Shared constants
export const WETH_ADDRESSES = {
    369: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
    943: '0x3677bd78ccf4d299328ecfba61790cf8dbfcf686',
};
export const OFF_RAMP_CONFIG = {
    feeManager: {
        369: '0xBa86ca0AECA30247F9E2fd8736879997bCD01dc4',
        943: '0x6dA4285Fc51217994cFa718Efc06bCcb1B6E5041',
    },
    omniBridge: {
        1: '0xd0764FAe29E0a6a96fF685f71CfC685456D5636c',
        11155111: '0x67e190aaF39b9E05b162A78ab94189446077C694',
    },
    wethOmniBridge: {
        1: '8ac4ae65b3656e26dc4e0e69108b392283350f55',
        11155111: '4e33d534FB1699f52a6d4C0BB2CF5fDC85d90bDC'.toLowerCase(),
    },
};
// Bridge constants
export const WPLS_FROM_PULSECHAIN = '0xa882606494d86804b5514e07e6bd2d6a6ee6d68a';
export const MAX_BALANCE_CUTOFF = 3690n * 10n ** 18n;
export const DEFAULT_SPONSORSHIP_AMOUNT_PLS = 3690n * (10n ** 18n);
export const DEFAULT_SPONSORSHIP_AMOUNT_ETH = 0n;
// PLSX Signature Message
export const PLSX_SIGNATURE_MESSAGE = 'I sacrificed for Freedom of Movement and Assembly';
